import { PublicTokenReadScopeGroup, PublicTokenWriteScopeGroup } from '@arhs-fleetback/types/entities/public-tokens';

import React from 'react';
import { FormattedMessage } from 'react-intl';

import { humanize, ucFirst } from 'utils/global';

export const MAX_TOKENS = 20;

export const SK_DEPRECATED = 'DEPRECATED';

export const PUBLIC_TOKEN = 'publicTokens-dashboard';

type ScopeSelectOption<T extends string> = {
  value: T;
  label: React.ReactNode;
};

const toScopeOptions = <T extends string>(scopeGroups: Record<string, T>): ScopeSelectOption<T>[] =>
  Object.values(scopeGroups).map(scopeGroup => ({
    value: scopeGroup,
    label: (
      <FormattedMessage id={`page.publicTokens.scopeGroup.${scopeGroup}`} defaultMessage={ucFirst(humanize(scopeGroup))} />
    ),
  }));

export const READ_SCOPE_OPTIONS = toScopeOptions(PublicTokenReadScopeGroup);

export const WRITE_SCOPE_OPTIONS = toScopeOptions(PublicTokenWriteScopeGroup);
